import { createContext, useContext } from "react";

export const BreadCrumbContext = createContext();

export function useBreadCrumbContext() {
  return useContext(BreadCrumbContext);
}
